module.exports = __webpack_public_path__ + "media/insure.e56f865b.mp3";